import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import appcolors from "../../constants/Colors";
import globalStyle from "../../globalStyle";
import GlobalButton from "../CustomButton";
import Label from "../Label";
import TextInput from "../TextInputs";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2, 3),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

const StatusBlockDialog = forwardRef(({ onConfirm }, ref) => {
  const [open, setOpen] = useState(false);
  const [dialogData, setDialogData] = useState({});
  const [reason, setReason] = useState("");
  const [error, setError] = useState(false);
  const recieverEmail =
    dialogData.type === "Supplier"
      ? dialogData?.data?.businessEmail
      : dialogData?.data?.email;

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      setDialogData(params);
      setOpen(true);
    },
    closeDialog() {
      handleClose();
    },
  }));

  const handleClose = () => {
    setOpen(false);
    setDialogData({});
    setReason("");
    setError(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="client-block-dialog-title"
      open={open}
    >
      <DialogTitle
        sx={{ m: 0, p: 2, textAlign: "center", color: "primary.main" }}
        id="client-block-dialog-title"
      >
        Do you want to {dialogData?.status} this {dialogData?.type}?
      </DialogTitle>
      <DialogContent dividers>
        <Label labelText="Provide a reason" required />
        <TextInput
          styleProps={{
            ...globalStyle.textField,
            "& .MuiOutlinedInput-root": {
              padding: "0px !important",
            },
          }}
          placeholder="10-100 words"
          multiline
          rows={4}
          inputError={error}
          helperText={error && "Reason is required"}
          value={reason}
          onChange={(e) => {
            setError(false);
            setReason(e.target.value);
          }}
        />
        <Typography variant="body2" my={1}>
          <span style={{ color: appcolors.primary }}>Note:</span> A confirmation
          email will be sent to {recieverEmail}.
        </Typography>
      </DialogContent>
      <DialogActions>
        <GlobalButton
          variant="outlined"
          btnText="Cancel"
          handleClickBtn={handleClose}
          styleProps={{
            height: 45,
          }}
        />
        <GlobalButton
          variant="contained"
          btnText="Yes"
          styleProps={{
            height: 45,
          }}
          handleClickBtn={() => {
            if (!reason.trim()) {
              setError(true);
            } else {
              onConfirm({ ...dialogData, reason });
            }
          }}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default StatusBlockDialog;
